// API endpoint URLs — only the live BiorGov ones.

// Auth
export const POST_JWT_LOGIN       = "/auth/login";
export const POST_JWT_LOGOUT      = "/auth/logout";
export const GET_ME               = "/auth/me";
export const POST_FORGOT_PASSWORD = "/auth/forgot-password";
export const POST_RESET_PASSWORD  = "/auth/reset-password";   // append /:token
export const POST_ACCEPT_INVITE   = "/auth/accept-invite";    // append /:token
export const POST_CHANGE_PASSWORD = "/auth/change-password";

// User administration (super-admin only)
export const ADMIN_USERS                = "/admin/users";
export const ADMIN_USER_BY_ID           = "/admin/users";          // append /:id
export const ADMIN_USERS_INVITE         = "/admin/users/invite";
export const ADMIN_USERS_RESEND_INVITE  = "/admin/users";          // append /:id/resend-invite
export const ADMIN_USERS_DEACTIVATE     = "/admin/users";          // append /:id/deactivate
export const ADMIN_ROLES                = "/admin/roles";
export const ADMIN_PERMISSIONS          = "/admin/permissions";

// Dashboard / Overview
export const GET_DASHBOARD_OVERVIEW     = "/dashboard/overview";
export const GET_TRANSACTION_ANALYTICS  = "/dashboard/analytics/transactions";
export const GET_DASHBOARD_SWAP_STATS   = "/dashboard/swap-stats";
export const EXPORT_DASHBOARD_DATA      = "/dashboard/export";

// Metrics
export const GET_DASHBOARD_METRICS = "/metrics/dashboard";
export const SYNC_BYB_TOKEN        = "/metrics/sync/byb-token";

// Notifications
export const NOTIFICATIONS = "/notifications";

// Transactions + Cards (JWT-gated dashboard endpoints)
export const GET_TRANSACTION_HISTORY    = "/transactions/history";
export const GET_TRANSACTION_STATISTICS = "/transactions/statistics";
export const GET_TRANSACTION_BY_ID      = "/transactions";        // append /:id
export const UPDATE_TRANSACTION_STATUS  = "/transactions";        // append /:id/status
export const GET_CARD_BY_ID             = "/transactions/cards";   // append /:id
export const GET_CARDS_BY_EMAIL         = "/transactions/cards/email"; // append /:email

// Paybis
export const GET_PAYBIS_LIST            = "/transactions/paybis/list";
export const GET_PAYBIS_COUNTS_BY_FLOW  = "/transactions/paybis/counts-by-flow";
export const GET_PAYBIS_HISTORY         = "/transactions/paybis/history";
export const GET_PAYBIS_STATISTICS      = "/transactions/paybis/statistics";
export const SYNC_PAYBIS_VOLUME         = "/transactions/paybis/sync-volume";
export const GET_PAYBIS_CURRENCIES      = "/transactions/paybis/currencies";
export const TEST_PAYBIS_CONNECTION     = "/transactions/paybis/test";

// App Metrics (Android / iOS store analytics)
export const GET_APP_METRICS_SUMMARY  = "/metrics/summary";
export const GET_APP_METRICS_TOTALS   = "/metrics/totals";
export const GET_APP_METRICS_GROWTH   = "/metrics/growth";
export const GET_APP_METRICS_CRASHES  = "/metrics/crashes";
export const GET_APP_METRICS_PLATFORM = "/metrics/platform";       // append /:platform
export const POST_APP_METRICS_SYNC    = "/metrics/app/sync";

// North Star — Weekly Engaged Wallets (WEW). Backend not built yet; the
// frontend degrades gracefully ("awaiting backend") until these ship.
// Contract: see BiorAdmin-Backend/docs/BIORGOV_DASHBOARD_BUILD_SPEC.md.
export const GET_WEW_SUMMARY          = "/metrics/wew/summary";
export const GET_WEW_TREND            = "/metrics/wew/trend";              // ?weeks=12
export const GET_WEW_PASS             = "/metrics/wew/pass-conditions";
export const GET_WEW_RETENTION        = "/metrics/wew/retention-cohorts";  // ?weeks=8
export const GET_WEW_COUNTERMEASURES  = "/metrics/wew/countermeasures";

// Chart event annotations (date + label markers on the WEW trend). Generic
// `chart_key` so the same layer can serve other charts later.
export const WEW_ANNOTATIONS          = "/metrics/wew/annotations";

// Traffic sources — first-touch split of the unique-visitors number.
export const GET_VISITOR_SOURCES      = "/visitors/sources";   // ?days=30 (omit = all-time)

// PR discipline — share of commits reaching the protected branches via a merged
// PR, plus review-latency and board-coverage supporting metrics.
export const GET_PR_DISCIPLINE_SUMMARY  = "/metrics/pr-discipline/summary";
export const GET_PR_DISCIPLINE_OPEN_PRS = "/metrics/pr-discipline/open-prs";
export const GET_PR_DISCIPLINE_STATUS   = "/metrics/pr-discipline/status";
export const POST_PR_DISCIPLINE_SYNC    = "/metrics/pr-discipline/sync";

// Founder Daily Tasks (issue #98) — super-admin-only widget on dashboard home
export const DAILY_TASKS = "/daily-tasks";

// Alerts (admin)
export const GET_ALERTS_ADMIN   = "/price-alerts/admin/all";
export const DELETE_ALERT_ADMIN = "/price-alerts/admin";          // append /:id

// Feedback
export const GET_FEEDBACK_CATEGORIES            = "/feedback/categories";
export const CREATE_FEEDBACK_CATEGORY           = "/feedback/categories";
export const GET_FEEDBACK_SUGGESTIONS           = "/feedback/suggestions";
export const GET_FEEDBACK_SUGGESTION_BY_ID      = "/feedback/suggestions";  // append /:id
export const UPDATE_FEEDBACK_SUGGESTION_STATUS  = "/feedback/suggestions";  // append /:id/status
export const DELETE_FEEDBACK_SUGGESTION         = "/feedback/suggestions";  // append /:id
export const GET_FEEDBACK_BUG_REPORTS           = "/feedback/bug-reports";
export const DELETE_FEEDBACK_BUG_REPORT         = "/feedback/bug-reports";  // append /:id
export const GET_FEEDBACK_DO_NOT_LIKE           = "/feedback/do-not-like";

// System checks (super-admin only)
export const GET_SYSTEM_CHECKS_DB       = "/system-checks/db";
export const GET_SYSTEM_CHECKS_EXTERNAL = "/system-checks/external";

// API Status — service_health table, populated every 2 min by the scheduler
export const GET_SERVICE_HEALTH_STATUS   = "/system-checks/status";
export const GET_SERVICE_HEALTH_HISTORY  = "/system-checks/status/history";
export const POST_SERVICE_HEALTH_RUN     = "/system-checks/status/run";
export const POST_SERVICE_HEALTH_RUN_ONE = "/system-checks/status";   // append /:service/run
export const PUT_SERVICE_HEALTH_IGNORE   = "/system-checks/status";   // append /:service/ignore

// App store reviews — unified Apple App Store + Google Play feed
export const GET_REVIEWS = "/reviews";

// App Errors (PostHog-synced crash / error events from the mobile app)
export const GET_APP_ERRORS          = "/errors";
export const GET_APP_ERRORS_SUMMARY  = "/errors/summary";
export const GET_APP_ERROR_BY_ID     = "/errors";             // append /:id
export const PATCH_APP_ERROR_RESOLVE = "/errors";             // append /:id/resolve
export const POST_APP_ERRORS_SYNC    = "/errors/sync";

// Fees (per-swap markup + batched SwapKit settlements)
export const GET_FEES_SUMMARY     = "/fees/summary";
export const GET_FEES_MISSING     = "/fees/missing";
export const GET_FEE_SETTLEMENTS  = "/fees/settlements";
export const POST_FEES_SYNC       = "/fees/sync";
export const GET_SWAPKIT_STATUS   = "/fees/swapkit/status";
export const POST_SWAPKIT_SYNC    = "/fees/swapkit/sync";
export const GET_RANGO_STATUS     = "/fees/rango/status";
export const GET_RANGO_SWAPS      = "/fees/rango/swaps";
export const POST_RANGO_SYNC      = "/fees/rango/sync";

// Event health (mobile-ping ingestion monitoring)
export const GET_EVENT_HEALTH_SUMMARY = "/event-health/summary";
export const GET_EVENT_HEALTH_ERRORS  = "/event-health/errors";

// Token listings (BiorAdmin-Backend proxies BiorLabs_backend
// /api/admin/token-listings/*; logo upload is stored by BiorAdmin-Backend).
export const TOKEN_LISTINGS             = "/token-listings";          // GET list, POST create; append /:id
export const TOKEN_LISTINGS_LOOKUP      = "/token-listings/lookup";
export const TOKEN_LISTINGS_LOGO        = "/token-listings/logo";

// Form Submissions (marketing-site contact form inbox)
export const GET_FORM_SUBMISSIONS         = "/admin/submissions";
export const GET_FORM_SUBMISSION_BY_ID    = "/admin/submissions";   // append /:id
export const PATCH_FORM_SUBMISSION        = "/admin/submissions";   // append /:id
export const DELETE_FORM_SUBMISSION       = "/admin/submissions";   // append /:id
export const GET_FORM_SUBMISSION_STATS    = "/admin/stats";
export const GET_FORM_SUBMISSION_EXPORT   = "/admin/export.csv";

// Rewards (Wank Rewards engine; BiorAdmin-Backend proxies these to the
// rewards API at /api/admin/rewards/*, attaching the server-held x-admin-key).
export const GET_REWARDS_PAYOUTS        = "/rewards/payouts";
export const POST_REWARDS_PAYOUT        = "/rewards/payouts";        // append /:id/record or /:id/cancel
export const GET_REWARDS_VAULT          = "/rewards/vault";
export const POST_REWARDS_VAULT_REFILL  = "/rewards/vault/refill";
export const POST_REWARDS_DROP_CODE     = "/rewards/drop-code";
export const POST_REWARDS_PRICE_PUBLISH = "/rewards/price/publish";
export const GET_REWARDS_PRICE          = "/rewards/price";          // active weekly snapshot
export const POST_REWARDS_REPLAY_CREDIT = "/rewards/replay-credit";  // append /:pollId
// Explorer (read-only analytics)
export const GET_REWARDS_WALLETS        = "/rewards/wallets";        // append /:address for detail
export const GET_REWARDS_REFERRALS      = "/rewards/referrals";
export const GET_REWARDS_TOP_REFERRERS  = "/rewards/leaderboard/referrers";
export const GET_REWARDS_REFERRAL_STATS = "/rewards/referral-stats";
// v2: claims queue + drops
export const GET_REWARDS_CLAIMS         = "/rewards/claims";
export const POST_REWARDS_DROP_CODES_BULK = "/rewards/drop-codes/bulk";
export const GET_REWARDS_DROP_CODES     = "/rewards/drop-codes";
export const POST_REWARDS_DROP_WHITELIST = "/rewards/drops/whitelist";
export const POST_REWARDS_DROP_SNAPSHOT = "/rewards/drops/snapshot";
export const GET_REWARDS_DROPS          = "/rewards/drops";

// CoinGecko API usage (BiorAdmin-Backend proxies BiorLabs_backend
// /api/coingecko/metrics — per-endpoint call counts, cache hit/savings, daily trend).
export const GET_COINGECKO_USAGE        = "/coingecko/usage";
